import { Alert } from "@msuite/ui/alert";
import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import { guardArray } from "@msuite/utils/array";
import type { DashboardAlert, Nullable } from "@msuite/utils/types";
import { client } from "@/hono";
import { useMentionOptions } from "@/hooks/use-mention-options";
import { useNavigate } from "react-router";

export function DashboardAlerts() {
	/** Hooks */
	const mentionsOptions = useMentionOptions();
	const navigate = useNavigate();

	/** Query */
	const { data: alerts } = useQuery({
		queryKey: ["dashboard", "alerts"],
		queryFn: async () => {
			const response = await client.dashboard.alerts.$get();
			const json = await responseHandler(response);
			return guardArray(json.alerts);
		},
	});

	/** Functions */
	function handleOnAlertClick(alert: DashboardAlert) {
		if (alert.href) {
			handleOnOpenHref(alert.href);
		} else {
			switch (alert.type) {
				case "missing-substitution": {
					navigate("/substitutions");
					break;
				}
			}
		}
	}

	function handleOnOpenHref(href: Nullable<string>) {
		if (href) {
			window.open(href, "_blank");
		}
	}

	if (!(alerts?.length || 0)) {
		return null;
	}

	/** Render */
	return (
		<div className="v-stack mb-2 gap-4">
			{guardArray(alerts)?.map((alert) => (
				<Alert
					key={alert.title}
					title={alert.title}
					description={alert.description}
					variant={alert.levelType}
					isDismissable={alert.isDismissable as any}
					dismissKey={("dismissKey" in alert ? alert.dismissKey : undefined) as any}
					mentionOptions={mentionsOptions}
					onClick={() => handleOnAlertClick(alert)}
				/>
			))}
		</div>
	);
}
